jQuery( document ).ready( function ( $ ) {
	if ( $( ".block-rows-with-pluses-leadership" ).length ) {
		let informationBlockHeight = document.querySelectorAll( '.rows-with-leader__right' );

		if ( window.innerWidth >= 860 ) {
			informationBlockHeight.forEach((elem)=>{
				let leaderFotoHeight = document.querySelector( '.leader-photo' ).offsetHeight;
				elem.style.height = `${leaderFotoHeight}px`;
			})
		}

		let allLeaderName = document.querySelectorAll('.leader-information__name');

		allLeaderName.forEach((name)=>{
			name.addEventListener( 'click', function ( e ) {
				const solutionsElement = e.target.closest( '.rows-with-leader__item' );

				if ( !solutionsElement ) {
					return true;
				}

				const isClosed = !solutionsElement.classList.contains( 'active' );
				const solutionsElements = document.querySelectorAll( '.rows-with-leader__item' );

				for ( let i = 0, n = solutionsElements.length; i < n; i ++ ) {
					solutionsElements[i].classList.remove( 'active' );
				}

				if ( isClosed ) {
					solutionsElement.classList.add( 'active' );
				}

			} );
		})

		window.addEventListener( 'resize', () => {
			if ( window.innerWidth >= 860 ) {
				informationBlockHeight.forEach((elem)=> {
					leaderFotoHeight = document.querySelector( '.leader-photo' ).offsetHeight;
					elem.style.height = `${leaderFotoHeight}px`;
				})
			} else {
				informationBlockHeight.forEach((elem)=> {
					elem.style.height = ``;
				})
			}
		} )
	}
} );
